import Vue from 'vue'
import VueRouter from 'vue-router'

//home
import Home from './Home'

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        { path: '/', redirect: '/home' },
        { path: '/home', name:'home', component: Home }
    ]
});

// 全局前置守卫
router.beforeEach((to, from, next) => { next(); });

// 全局后置
router.afterEach(() => {});

export default router;
